module.exports = __webpack_public_path__ + "static/media/soc-tw-white.8ac94474.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/soc/soc-tw-white.svg
// module id = 935
// module chunks = 270